var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React from 'react';
import styled from 'styled-components';
var StyledForm = styled.form(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));

var Form =
/** @class */
function (_super) {
  __extends(Form, _super);

  function Form(props) {
    var _this = _super.call(this, props) || this;

    _this.changeCallback = function (attribute) {
      var _a = _this.props,
          handleChange = _a.handleChange,
          id = _a.id;
      handleChange && handleChange(_this.state, id, attribute);
    };

    _this.handleInternalState = function (e) {
      var _a;

      var target = e.target;
      var value = target.value;

      switch (target.type) {
        case 'checkbox':
          value = target.checked;
          break;

        case 'select-multiple':
          {
            var values = [];

            for (var i = 0; i < target.options.length; i++) {
              if (target.options[i].selected) {
                values.push(target.options[i].value);
              }
            }

            value = values;
            break;
          }

        default:
          break;
      }

      _this.setState(__assign(__assign({}, _this.state), (_a = {}, _a[target.name] = value, _a)), function () {
        return _this.changeCallback(target.name);
      });
    };

    _this.state = props.defaults || {}; // allows default state

    return _this;
  }

  Form.prototype.render = function () {
    return React.createElement(StyledForm, {
      onChange: this.handleInternalState
    }, this.props.children);
  };

  return Form;
}(React.Component);

export default Form;
var templateObject_1;